/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Delete_User_ButtonInputs */



/**
* | output |
* | --- |
* | "Delete User" |
*
* @param {Team_Manager_Delete_User_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_delete_user_button = /** @type {((inputs?: Team_Manager_Delete_User_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Delete_User_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer l’utilisateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzer löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina utente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить пользователя")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar usuario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除用户")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザーの削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir usuário")
	return /** @type {LocalizedString} */ ("Delete User")
});